// extracted by mini-css-extract-plugin
export default {"card":"CardInfo_card__VlLCn","card__value":"CardInfo_card__value__Mv6Af","card__link":"CardInfo_card__link__iY68W"};